var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReqHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.0829C76.1632 3.08119 86.8368 3.08119 95.5 8.0829L138.081 32.6671C146.744 37.6688 152.081 46.9124 152.081 56.9158V106.084C152.081 116.088 146.744 125.331 138.081 130.333L95.5 154.917C86.8368 159.919 76.1632 159.919 67.5 154.917L24.9189 130.333C16.2557 125.331 10.9189 116.088 10.9189 106.084V56.9158C10.9189 46.9124 16.2557 37.6688 24.9189 32.6671L67.5 8.0829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13.3301C77.641 10.6506 83.359 10.6506 88 13.3301L135.787 40.9199C140.428 43.5994 143.287 48.5513 143.287 53.9103V109.09C143.287 114.449 140.428 119.401 135.787 122.08L88 149.67C83.359 152.349 77.641 152.349 73 149.67L25.2132 122.08C20.5721 119.401 17.7132 114.449 17.7132 109.09V53.9103C17.7132 48.5513 20.5721 43.5994 25.2132 40.9199L73 13.3301Z",
    fill: "url(#paint0_linear_947_10943)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16.7528C78.0222 14.4306 82.9778 14.4306 87 16.7528L133.323 43.4972C137.345 45.8195 139.823 50.1111 139.823 54.7556V108.244C139.823 112.889 137.345 117.181 133.323 119.503L87 146.247C82.9778 148.569 78.0222 148.569 74 146.247L27.6773 119.503C23.655 117.181 21.1773 112.889 21.1773 108.244V54.7556C21.1773 50.1111 23.655 45.8195 27.6773 43.4972L74 16.7528Z",
    fill: "url(#paint1_linear_947_10943)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0315 58.4884H69.994C67.9005 58.4884 66.2015 56.7895 66.2015 54.6959V48.9175C66.2015 46.8239 67.9005 45.125 69.994 45.125H92.0315C94.1251 45.125 95.824 46.8239 95.824 48.9175V54.6959C95.824 56.7921 94.1251 58.4884 92.0315 58.4884Z",
    fill: "url(#paint2_linear_947_10943)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.884 51.813H99.6678V54.6958C99.6678 58.906 96.2417 62.3321 92.0315 62.3321H69.994C65.7813 62.3321 62.3578 58.906 62.3578 54.6958V51.813H59.1675C54.0937 51.813 49.9937 55.913 49.9937 60.9867V107.701C49.9937 112.775 54.0937 116.875 59.1675 116.875H102.832C107.906 116.875 112.006 112.775 112.006 107.701V60.9867C112.006 55.8874 107.957 51.813 102.884 51.813ZM77.023 89.8226H65.9068C64.6333 89.8226 63.6006 88.7899 63.6006 87.5163C63.6006 86.2427 64.6333 85.2101 65.9068 85.2101H77.023C78.2965 85.2101 79.3292 86.2427 79.3292 87.5163C79.3292 88.7899 78.2965 89.8226 77.023 89.8226ZM90.635 76.7333H65.9068C64.6333 76.7333 63.6006 75.7006 63.6006 74.4271C63.6006 73.1535 64.6333 72.1208 65.9068 72.1208H90.6324C91.906 72.1208 92.9387 73.1535 92.9387 74.4271C92.9387 75.7006 91.9085 76.7333 90.635 76.7333Z",
    fill: "url(#paint3_linear_947_10943)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_947_10943",
    x1: 80.5,
    y1: 9,
    x2: 80.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_947_10943",
    x1: 80.5,
    y1: 13,
    x2: 80.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_947_10943",
    x1: 81.0128,
    y1: 45.125,
    x2: 81.0128,
    y2: 58.4884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_947_10943",
    x1: 81,
    y1: 51.813,
    x2: 81,
    y2: 116.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReqHistoryIcon);
export default __webpack_public_path__ + "static/media/no-req-history-icon.cb9272f5885d72ad45adc6cf9ecd0fde.svg";
export { ForwardRef as ReactComponent };